<template>
  <div :class="['share-header', external && 'external', isHeaderFold && 'fold']">
    <div v-if="!(external && isHeaderFold)" class="share-meta">
      <avatar v-if="external" :user="process.share_link.owner" :size="30"/>
      <div :class="[!process.share_link.description && 'only-title']">
        <span class="sharer-name">{{shareName}}</span>
        <span class="share-type">{{shareType}}</span>
        <p v-if="process.share_link.description" class="description">{{$t('share.desc.mark', [process.share_link.description])}}</p>
      </div>
    </div>
    <div v-if="external && fileItem" class="share-item">
      <div class="thumb-icon">
        <thumb-icon
          :type="fileItem.type"
          :name="fileItem.name"
          :thumbnail="fileItem.thumbnail"
          :space="fileItem.space"
          :typeIcon="fileItem.type_icon"
          scenario="share"
        />
      </div>
      <div class="item-main">
        <div class="file-name ellipsis">{{fileItem.name}}</div>
        <div class="file-size">{{fileItem.approxSize}}</div>
      </div>
      <div v-if="external" :class="['fold-btn', isHeaderFold && 'fold']" @click="triggerFold"><i class="iconfont icon-Expand"></i></div>
    </div>
    <div v-if="!external" class="share-time">
      <div class="process-id"><span>{{$t('share.no')}}</span>{{process.serial_number}}</div>
      <div class="process-time"><span>{{$t('share.created')}}</span>{{created}}</div>
    </div>
  </div>
</template>
<script>
import {formatDate} from '@/utils/common'
import {i18n} from '@/utils/i18n'
import Avatar from '../utils/Avatar'

export default {
  name: 'ShareHeader',
  i18n,
  components: {
    Avatar
  },
  props: {
    external: Boolean,
    process: Object,
    fileItem: Object,
    isHeaderFold: Boolean
  },
  computed: {
    shareName () {
      return this.process.share_link.owner.name
    },
    shareType () {
      return this.fileItem && this.fileItem.type === 'folder' ? i18n.t('message.list.sharedFolderToYou') : i18n.t('message.list.sharedFileToYou')
    },
    created () {
      return formatDate(this.process.created * 1000, '%YY-%MM-%DD %hh:%mm')
    }
  },
  methods: {
    triggerFold () {
      this.$emit('trigger-fold')
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';

.share-header {
  background: #fff;
  padding: 15px;
  margin-bottom: 10px;

  &.external {
    flex: 0 0 auto;

    & * {
      /* transition: all .2s; */
    }

    & .share-meta {
      display: flex;
      font-size: 14px;
    }

    & .only-title {
      padding-top: 5px;
    }

    & .avatar {
      flex: 0 0 auto;
      margin-right: 6px;
    }

    & .sharer-name {
      margin: 0 6px 0 0;
    }
  }

  & .sharer-name {
    word-break: break-all;
  }

  & .description {
    color: var(--secondlyText);
    font-size: 12px;
    word-break: break-all;
    white-space: pre-line;
  }

  & .share-item {
    position: relative;
    display: flex;
    align-items: center;
    padding: 10px 15px 0 35px;

    & .thumb-icon {
      flex: 0 0 auto;
      width: 40px;
      height: 40px;
      margin-right: 14px;

      & img,
      & svg {
        width: 100%;
        height: 100%;
      }
    }

    & .item-main {
      flex: 1 1 auto;
      overflow: hidden;

      & .file-name {
        font-size: 16px;
      }

      & .file-size {
        font-size: 12px;
        color: #848484;
      }
    }

    & .fold-btn {
      position: absolute;
      right: -5px;
      bottom: -5px;
      width: 26px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      color: #b2b7ca;

      &.fold {
        transform: rotate(180deg);
      }
    }
  }

  &.fold {
    padding: 12px 15px;

    & .share-item {
      padding: 0 20px 0 0;

      & .thumb-icon {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }

      & .file-name {
        font-size: 14px;
      }

      & .file-size {
        display: none;
      }
    }

    & .fold-btn {
      bottom: 0;
    }
  }

  & .share-time {
    color: var(--secondlyTitle);
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid var(--sepLineColor);
    line-height: 22px;
    font-size: 12px;

    & span {
      color: var(--secondlyText);
      display: inline-block;
      width: 48px;
      text-align: right;
      padding-right: 22px;
    }
  }
}
</style>
